const siteSectionValue="CROSS SELL-APPLY";
const siteSectionValue2="CROSS:SELL-APPLY";
const siteSectionValue3="CROSS:SELL:Apply";

export const loanCustomerInfoDataLayer={
  "pageName": "CROSS SELL:PERSONAL INFO",
  "siteSection": siteSectionValue,
  "marketCode": "OPENMARKET"
};

export const declineOfferDataLayer={
  "pageName": "CL:CROSSSELL:DECISION:DECLINED",
  "siteSection": siteSectionValue,
  "marketCode": "OPENMARKET"
};

export const personalizeDataLayer={
  "pageName": "CROSS:SELL:STEP1:PERSONALIZE",
  "siteSection": siteSectionValue2
};

export const bankDetailsDataLayer={
  "pageName": "CROSS:SELL:STEP2:BANKDETAILS",
  "siteSection": siteSectionValue2
};

export const addBankDataLayer={
  "pageName": "CROSS:SELL:STEP2(a):ADDBANK",
  "siteSection": siteSectionValue2
};

export const confirmDataLayer={
  "pageName": "CROSS:SELL:STEP3:REVIEW",
  "siteSection": siteSectionValue2
};

export const successDataLayer={
  "pageName": "CROSS:SELL:STEP4:SUCCESS",
  "siteSection": siteSectionValue2
};
export const acceptedDataLayer={
  "pageName": "CROSS:SELL:Loan:Accepted:Email",
  "siteSection": siteSectionValue2
};

export const applyExitDataLayer={
  "pageName": "CROSS:SELL:EXIT",
  "siteSection": siteSectionValue2
};

export const truthNLendingDataLayer={
  "pageName": "CROSS:SELL:STEP3(a):LoanAgreement",
  "siteSection": siteSectionValue2
};

export const otpSelectionDataLayer={
  "pageName": "CROSS:SELL:OTP:SELECTION",
  "siteSection": siteSectionValue3
};

export const otpEnterPinDataLayer={
  "pageName": "CROSS:SELL:OTP:ENTER:PIN",
  "siteSection": siteSectionValue3
};

export const rsaDataLayer={
  "pageName": "CROSS:SELL:RSA",
  "siteSection": siteSectionValue3
};

export const veridDataLayer={
  "pageName": "CROSS:SELL:VERID",
  "siteSection": siteSectionValue3
};

export const kbvDataLayer={
  "pageName": "CROSS:SELL:KBV",
  "siteSection": siteSectionValue3
};
